<template>
  <b-modal id="question-modal" modal-class="content-only modal-large" size="lg"
           :no-close-on-backdrop="loading" @hide="reset"
           content-class="question-content" ref="modal" centered>
    <div class="question-form">
      <div class="top">
        <h3 class="title">{{ formTitle }}</h3>
        <p class="description">
          {{ formDescription }}
        </p>
        <button class="close btn btn-gray btn-square" @click="hide"><i class="ti-close"></i></button>
      </div>
      <ValidationObserver ref="form">
        <div class="content mt-2">
          <div class="header">
            <div class="profile">
              <img class="avatar" :src="user.avatar" alt="">
              <div class="data">
                <span class="name">{{ user.full_name }}</span>
                <div class="classe">{{ classroom.name }}</div>
              </div>
            </div>
            <div v-if="!isResponse" class="subject">
              <select v-model="subject_id" class="form-control" name="subject" id="subject">
                <option value="">Matière</option>
                <option v-for="(subject,i) in subjects" :value="subject.id">{{ subject.name }}</option>
              </select>
            </div>
          </div>
          <div class="form mt-4">
            <ValidationProvider v-if="!isResponse" rules="required" v-slot="{ errors }">
              <div class="form-group">
                <label>Intitulé de la question</label>
                <input :class="{'is-invalid':!!errors[0]}" type="text" name="title" v-model="title"
                       class="form-control">
                <span class="invalid-feedback">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="form-group">
                <textarea :class="{'is-invalid':!!errors[0]}" class="form-control" name="content"
                          v-model="content"></textarea>
                <span class="invalid-feedback">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <div class="image-list" v-if="images.length">
              <figure v-for="(image,i) in images" class="teaser teaser-simple">
                <img :src="image.path" :alt="image.name">
                <figcaption>
                  <button @click="images.splice(i,1)" class="btn btn-gray btn-square">
                    <i class="ti-trash" style="font-size: 20px"></i>
                  </button>
                </figcaption>
              </figure>
            </div>
            <div class="audio-container d-flex align-items-center" v-if="audio">
              <audio-player class="audio-player" :src="audio.url" :record="audio.record"/>
              <div style="width: 50px" class="text-right">
                <button class="btn btn-gray btn-square" @click="audio=null">
                  <i class="ti-trash" style="font-size: 20px"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </ValidationObserver>
      <div class="bottom">
        <div class="left">
          <span>Associer un média</span>
          <input ref="fileInput" type="file" accept="image/*" @change="fileChange" class="d-none">
          <button @click="$refs.fileInput.click()" class="btn btn-square btn-gray">
            <img src="@img/image.svg" alt="">
          </button>
          <button v-if="!audio" @click="toggleRecord" class="btn btn-square btn-gray">
            <img v-if="!isRecording" src="@img/mic.svg" alt="">
            <span v-else style="width: 20px;height: 20px;background: #555;display: block"></span>
          </button>
          <span class="time" v-if="isRecording">{{ recordedTime }}</span>
        </div>

        <button @click="validateAndSubmit" class="btn px-4 btn-outline-green">{{ id ? 'Modifier' : 'Publier' }}</button>
      </div>
    </div>
    <div class="loader absolute" v-if="loading && !hasFiles"></div>
    <div class="request-progress" v-if="loading && hasFiles">
      <h4 class="text-center">Envoi de vos fichiers</h4>
      <b-progress variant="primary" :striped="true" :animated="true" :max="100">
        <b-progress-bar :label="`${progress}%`" :value="progress"></b-progress-bar>
      </b-progress>
    </div>
  </b-modal>
</template>

<script>
import {mapGetters} from "vuex";
import {AudioPlayer} from 'vue-audio-recorder'
import axios from "axios";
import RecorderMixin from "@/components/Mixins/RecorderMixin.js";

export default {
  name: "QuestionForm",
  components: {
    AudioPlayer
  },
  mixins: [RecorderMixin],
  data() {
    return {
      response_to: null,
      id: null,
      title: '',
      content: '',
      subject_id: '',
      images: [],
      audio: null,
      loading: false,
      progress: 0,
      hasFiles: false
    }
  },
  computed: {
    ...mapGetters({user: 'user', classroom: 'classroom', subjects: 'subject/subjects'}),
    isResponse() {
      return !!this.response_to
    },
    toastMessage() {
      if (this.response_to) {
        return this.id ? 'Votre réponse a été modifiée' : 'Votre réponse a été enregistrée'
      }
      return this.id ? 'Votre question a été modifiée' : 'Votre question a été enregistrée'
    },
    formTitle() {
      if (this.response_to) {
        return this.id ? 'Modifier votre réponse' : 'Envoyer une réponse'
      }
      return this.id ? 'Modifier votre question' : 'Ajouter une question'
    },
    formDescription() {
      if (this.response_to) {
        return this.id ? 'Modifier les éléments de votre réponse avec ce formulaire' : 'Remplisser les éléments du formulaire pour envoyer votre réponse'
      }
      return this.id ? 'Modifier les éléments de votre question avec ce formulaire' : 'Remplisser les éléments du formulaire pour poser votre question'
    }
  },
  methods: {
    reply(question) {
      this.response_to = question.id
      this.show()
    },
    edit(question) {
      this.init(question)
      this.show()
    },
    show() {
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
    init(question) {
      this.id = question.id
      this.title = question.title
      this.content = question.content
      this.images = question.images.map(i => ({name: i.file_name, path: i.path, id: i.id}))
      if (question.audio) this.audio = {url: question.audio}
    },
    fileChange(event) {
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i]
        this.images.push({
          name: file.name,
          path: URL.createObjectURL(file),
          file: file
        })
      }
      event.target.value = ""
    },
    validateAndSubmit() {
      this.$refs.form.validate().then(result => {
        if (result) this.submit()
      })
    },
    submit() {
      const data = new FormData()
      data.append('title', this.title)
      data.append('content', this.content)
      if (this.subject_id) data.append('subject_id', this.subject_id)
      if (this.audio && this.audio.record) {
        data.append('audio', this.audio.record.blob)
      }
      let idx = 1
      this.images.forEach(function (img) {
        if (img.file) data.append('image' + idx++, img.file)
      })
      data.append('images_count', idx - 1)
      this.hasFiles = idx > 1 || (this.audio && this.audio.record)
      let url = '/question'
      if (this.id) {
        data.append('_method', 'patch')
        const preserve_images = []
        this.images.forEach(img => {
          if (img.id) preserve_images.push(img.id)
        })
        data.append('preserve_images', JSON.stringify(preserve_images))
        url = '/question/' + this.id
      }
      if (this.response_to) data.append('response_to', this.response_to)

      this.progress = 0
      this.loading = true
      axios.post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        }
      })
        .then(resp => {
          this.hide()
          this.$emit('refresh')
          this.$toast.fire({
            icon: 'success',
            title: this.toastMessage
          })
        })
        .catch(e => {
          console.log(e);
          this.$toast.fire({
            'icon': 'error',
            title: 'Une erreur est survenue'
          })
        })
        .finally(() => this.loading = false)
    },
    reset() {
      this.id = null
      this.response_to = null
      this.subject_id = ''
      this.title = ''
      this.content = ''
      this.images = []
      this.audio = null
    }
  },
  mounted() {
    if (this.subjects.length === 0) this.$store.dispatch('subject/fetchClassroomSubjects')
    this.$root.$on('reply-question', question => this.reply(question))
    this.$root.$on('edit-question', question => this.edit(question))
  },
  beforeDestroy() {
    this.$root.$off('reply-question')
    this.$root.$off('edit-question')
  }
}
</script>

<style lang="scss">
.modal.content-only {
  .modal-header, .modal-footer {
    display: none;
  }
}

.question-content .modal-body {
  padding: 20px 40px;
  @include down(768) {
    padding: 15px 10px;
  }
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  @include gap-items-x(1.66%);

  > * {
    &:nth-child(5n) {
      margin-left: 0;
    }

    &:nth-child(5n+4) {
      margin-right: 0;
    }
  }

  figure {
    margin-bottom: 10px;
    width: 22.5%;
    height: auto;
    max-height: 100px;
  }
}

.question-form {
  .top {
    text-align: center;
    position: relative;

    .title {
      font-weight: 600;
      font-size: 28px;
      @include down(768) {
        font-size: 20px;
      }
      color: black;
    }

    .description {
      color: #1C1C1C;
      font-size: 16px;
      font-weight: 300;
    }

    button.close {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .content {
    .header {
      display: flex;
      justify-content: space-between;
      @include down(768) {
        flex-direction: column;
      }

      .subject {
        select {
          width: 200px;
          background: #F2F2F2;
          border: none;
          outline: none;
          box-shadow: none !important;
        }

        @include down(768) {
          margin: 10px 0;
        }
      }

      .profile {
        display: flex;
        align-items: center;

        .avatar {
          margin-right: 10px;
          @include square(50px);
        }

        .name {
          font-weight: 600;
          max-width: 150px;
          @include no-break();
        }

        .classe {
          color: $green;
          font-weight: 500;
        }
      }
    }

    .form {
      font-weight: 300;

      input {
        background: $gray;
        outline: none;
        border: none;
        box-shadow: none !important;
      }

      textarea {
        box-shadow: none !important;
      }
    }
  }

  .bottom {
    display: flex;
    margin-top: 10px;
    padding-top: 5px;
    border-top: 1px solid #ccc;
    justify-content: space-between;
    align-items: center;

    .left {
      display: flex;
      align-items: center;
      margin-right: 20px;
      @include gap-items-x(4px);

    }


  }
}

.request-progress {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  background: rgba($gray, .85);
  padding: 50px;
}

</style>
